import { gql } from '@apollo/client';

export interface SaveWorkflowTemplateInput {
    templateKey: string;
    name: string;
    bizType: string;
    version: number;
    status: number;
    definitionJson: string;
    description?: string | null;
}

export interface SaveWorkflowTemplateResponse {
    saveWorkflowTemplate: boolean;
}

export interface SaveWorkflowTemplateVariables {
    input: SaveWorkflowTemplateInput;
}

export const SAVE_WORKFLOW_TEMPLATE = gql`
    mutation SaveWorkflowTemplate($input: SaveWorkflowTemplateInput!) {
        saveWorkflowTemplate(input: $input)
    }
`;

